import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import SkipLink from './SkipLink';
import Container from '../ui/Container';
import { RouteLoading } from './MarketingLayout';

/**
 * Reserved shell for the future authenticated client portal and AI assistant
 * surface (route prefix: /portal).
 *
 * ARCHITECTURAL PLACEHOLDER: no authentication, session handling, or API
 * integration is implemented here, and no AWS infrastructure is created.
 * This shell exists so the marketing site and the application surface can
 * evolve independently without restructuring the router.
 */
const PortalLayout = () => (
  <div className="app-shell">
    <SkipLink />
    <header className="portal-header">
      <Container className="between">
        <span className="portal-header__title">Client Portal</span>
        <span className="text-small portal-header__note">Placeholder surface</span>
      </Container>
    </header>

    <main className="app-main" id="main-content" tabIndex={-1}>
      <Suspense fallback={<RouteLoading />}>
        <Outlet />
      </Suspense>
    </main>

    <footer className="portal-footer">
      <Container>
        <p className="text-small mb-0">
          The client portal is not enabled in this build.
        </p>
      </Container>
    </footer>
  </div>
);

export default PortalLayout;
